<template>
  <div>
    <div class="position-relative">
      <nav-bar :title="'Student Register'" :hideBackButton="isFirstTime"></nav-bar>
      <avatar
        :avatar-bank="avatarImagesBank"
        :currentAvatar="selectedAvatar"
        @selectAvatar="selectAvatar"
        class="avatarSelector"
        ref="avatar"
      />
    </div>
    <div class="childRegister atm-desktop-max-width mobile mx-auto">
      <b-form onsubmit="return false;" class="d-flex flex-wrap gap-4 mt-5">
        <div class="position-relative d-flex flex-wrap justify-content-center gap-4 w-100">
          <div
            class="d-flex flex-wrap gap-4 flex-grow-1 justify-content-center align-content-center align-items-center w-50"
          >
            <input
              type="text"
              v-model="childName"
              class="atm-input flex-grow-1"
              maxlength="20"
              placeholder="First Name"
              required
            />
            <input
              type="text"
              v-model="childLastName"
              class="atm-input flex-grow-1"
              placeholder="Last Name"
              required
            />
            <select v-model="selectedGenre" class="atm-input flex-grow-1" required>
              <option v-for="genre in genreOptions" :value="genre.value" :key="genre.value">{{
                genre.text
              }}</option>
            </select>
            <input
              type="date"
              v-model="childAge"
              class="atm-input  flex-grow-1"
              placeholder="Birthdate"
              required
            />
          </div>
        </div>
        <small class="text-muted d-block">
          Activate at least one module so that your student can start.</small
        >
        <manage-modules
          ref="modules"
          :register="true"
          class="mb-4"
          :modules="modulesList"
          @onModuleSelectionChange="moduleSelectionChange"
        ></manage-modules>
        <input
          type="email"
          v-model="childEmail"
          placeholder="Student Email"
          class="atm-input w-100"
          required
        />
        <div class="passwordInput flex-wrap d-flex gap-4 w-100 mb-4">
          <div class="d-flex position-relative flex-grow-1">
            <input
              id="childPass"
              type="password"
              v-model="childPass"
              class="atm-input flex-grow-1"
              placeholder="Student password"
              required
            />
            <a class="position-absolute" @click="showPass()">
              <span v-if="!showButtonPass" class="material-icons align-middle cursor"
                >visibility</span
              >
              <span v-else class="material-icons align-middle cursor">visibility_off</span>
            </a>
          </div>
          <div class="d-flex position-relative flex-grow-1">
            <input
              id="childRepass"
              type="password"
              v-model="childRepass"
              class="atm-input flex-grow-1"
              placeholder="Confirm password"
              required
            />
            <a class="position-absolute" @click="showRepass()">
              <span v-if="!showButtonRepass" class="material-icons align-middle cursor">
                visibility
              </span>
              <span v-else class="material-icons align-middle cursor">
                visibility_off
              </span>
            </a>
          </div>
        </div>
        <small v-if="childPass != childRepass" class="text-danger pb-1 w-100">
          Passwords don't match.
        </small>

        <small v-if="errorMessage" class="text-danger  pb-1 w-100">
          {{ errorMessage }}
        </small>
        <small v-if="errorMessage == 'Password is too weak'" class="text-danger w-100">
          The password should be at least 8 characters in length <br />
          Contain at least 3 of the following 4 types of characters <br />
          - Lowercase letters (a-z) <br />
          - Uppercase letters (A-Z) <br />
          - Numbers <br />
          - Special characters (e.g. !@#$%^*) <br />
        </small>
        <button
          type="submit"
          class="atm-button flex-grow-1 bg-main mx-auto w-25"
          :disabled="childPass != childRepass"
          @click="save(true)"
        >
          Save and add another
        </button>
        <button
          type="submit"
          class="atm-button flex-grow-1 bg-main mx-auto w-25"
          :disabled="childPass != childRepass"
          @click="save(false)"
        >
          Save
        </button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { getAvatarImagesBank } from '@/gamification';
import { getModuleSkills } from '@/module';
import { registerChild } from '../../services';
import { setDisableFirstTime } from '@/onBoard/services';
import { getChildrenData } from '@/auth';
import NavBar from '@/common/components/NavBar';
import ManageModules from '@/module/components/ManageModules';
import Avatar from '@/common/components/Avatar';
import { validateEmail } from '@/auth/utils';
import { GENRE_OPTIONS } from '@/common/utils';

export default {
  components: {
    NavBar,
    ManageModules,
    Avatar,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      modulesList: [],
      avatarImagesBank: [],
      childName: '',
      childLastName: '',
      childAge: '',
      childEmail: '',
      childPass: '',
      childRepass: '',
      showButtonPass: false,
      showButtonRepass: false,
      errorMessage: null,
      emptyModules: null,
      selectedAvatar: {
        id: 0,
        image: '',
      },
      modulesSelected: [],
      selectedGenre: null,
      genreOptions: [{ value: null, text: 'Select a genre' }, ...GENRE_OPTIONS],
    };
  },
  computed: {
    userId() {
      return this.sessionStore.userId;
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    isFirstTime() {
      return this.sessionStore.isFirstTime;
    },
  },
  methods: {
    moduleSelectionChange(selection) {
      this.modulesSelected = selection;
    },
    showPass() {
      let tipo = document.getElementById('childPass');
      if (tipo.type == 'password') {
        tipo.type = 'text';
        this.showButtonPass = true;
      } else {
        tipo.type = 'password';
        this.showButtonPass = false;
      }
    },
    showRepass() {
      let tipo = document.getElementById('childRepass');
      if (tipo.type == 'password') {
        tipo.type = 'text';
        this.showButtonRepass = true;
      } else {
        tipo.type = 'password';
        this.showButtonRepass = false;
      }
    },
    cleanFields() {
      (this.childName = ''),
        (this.childLastName = ''),
        (this.childAge = ''),
        (this.childEmail = ''),
        (this.childPass = ''),
        (this.childRepass = ''),
        (this.selectedAvatar = {
          id: 0,
          image: '',
        });
      this.modulesSelected = [];
      this.$refs.modules.clean();
      this.$refs.avatar.clean();
    },

    async save(addAnotherChild) {
      this.errorMessage = '';
      if (this.modulesSelected.length == 0) {
        this.errorMessage = 'Please activate at least one module.';
        return;
      }
      if (!this.allFieldAreComplete()) {
        this.errorMessage = 'Please complete all fields.';
        return;
      }
      if (!validateEmail(this.childEmail)) {
        this.errorMessage = 'please enter a valid email.';
        return;
      }
      const modules = this.modulesSelected.map((module) => {
        return {
          id: module,
        };
      });

      const informationToBeRegistered = {
        name: this.childName,
        last_name: this.childLastName,
        modulesUnlocked: modules,
        email: this.childEmail,
        birthdate: this.childAge,
        password: this.childPass,
        re_password: this.childRepass,
        profile_gender: this.selectedGenre,
        avatarId: this.selectedAvatar.id,
      };

      try {
        await registerChild(informationToBeRegistered);
        if (addAnotherChild) {
          this.cleanFields();
        } else {
          if (this.sessionStore.isFirstTime) {
            await setDisableFirstTime(this.userId, { isChild: !this.userIsAParent });
          }
          await getChildrenData(this.userId);
          this.$router.push({ name: 'home' });
        }
      } catch (error) {
        console.error(error);
      }
    },
    allFieldAreComplete() {
      return !(
        this.childName == '' ||
        this.childLastName == '' ||
        this.childAge == '' ||
        this.childEmail == '' ||
        this.childPass == '' ||
        this.childRepass == ''
      );
    },
    selectAvatar(image) {
      this.selectedAvatar = image;
    },
  },
  async mounted() {
    let requestsReponses = await Promise.all([getAvatarImagesBank(), getModuleSkills()]);
    this.avatarImagesBank = requestsReponses[0];
    this.modulesList = requestsReponses[1];
  },
};
</script>
<style lang="scss">
.passwordInput {
  & > div {
    & > a {
      padding: 0.5rem;
      top: 3px;
      right: 3px;
    }
  }
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.childRegister {
  padding-top: 5rem;

  @media (max-width: 768px) {
    padding-top: 3rem;
  }
}

.avatarSelector {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 10%;
  right: 5%;

  @media (max-width: 992px) {
    top: 10%;
    right: 5%;
  }

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    top: 50%;
    right: 5%;
  }
}
</style>
